export class ListInventoryTagsResponse {
    'tags';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<ResourceTag>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventoryTagsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
